module.exports = __webpack_public_path__ + "img/link.5c3d434e.svg";